import { state } from './types';

export default {
  [state.COHORTS]: [],
  [state.COHORT]: { id: null },
  [state.IS_LOADING]: false,
  [state.COLLECTION]: {},
  [state.UNFILTERED_DATA]: [],
  [state.FILTERED_DATA]: [],
  [state.DATA]: [],
  [state.INPUT_VARIABLES]: [],
  [state.OUTPUT_VARIABLES]: [],
  [state.CROSS_FILTER]: null,
  [state.DIMENSIONS]: {},
  [state.PVALS]: [],
  [state.PVALS_REQUEST_NUM]: 0,
  [state.PVALS_REQUEST_DELAY_SECS]: 1,
  [state.PVALS_REQUEST_STATUS]: null,
  [state.PVAL_THRESHOLD]: 0.05,
  [state.ANOVA_PVALS]: [],
  [state.ANOVA_PVALS_REQUEST_NUM]: 0,
  [state.ANOVA_PVALS_REQUEST_DELAY_SECS]: 1,
  [state.ANOVA_PVALS_REQUEST_STATUS]: null,
  [state.ODDS_RATIO]: {},
  [state.ODDS_RATIO_ERROR]: null,
  [state.ODDS_RATIO_REQUEST_NUM]: 0,
  [state.ODDS_RATIO_REQUEST_DELAY_SECS]: 1,
  [state.ODDS_RATIO_REQUEST_STATUS]: null,
  [state.HIGHLIGHTED_SUBSET]: 'cohort',
  [state.QUERIES]: {},
  [state.COMPARISON_MEASURE]: 'Last Visit',
  [state.USE_LONG_SCALE_NAMES]: false,
  [state.HELP_MODE]: false,
  [state.SORT]: 'Default',
  [state.SELECTED_ANALYSIS_MODE]: 'Predictor based',
  [state.CV_METADATA]: {},
  [state.CURRENT_ANALYTICS_TAB]: 0,
};
